import React, { useEffect, useState } from 'react'
import CollectionName from './partial/CollectionName';
import CategoryName from './partial/CategoryName';
import ActivityTab from './partial/ActivityTab';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const CollectionMaster = () => {
    const navigate = useNavigate();
    const user = useSelector(store => store.userstatus.tba);
    const [selectTab, setSelectTab] = useState(1);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    useEffect(() => {
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });
    }, [user])
    
    return (
        <div>
            <div className="container-fluid mt-4 heading_color">
                <h3>Collection, Category, Activity Master</h3>
            </div>
            <div className='container-fluid mt-3 tab_section px-0'>
                <ul className="nav nav-pills nav-justified mb-3 pt-3" id="pills-tab" role="tablist">
                    <li className="nav-item mx-lg-5 mx-md-1 mx-5 mt-1" role="presentation">
                        <button
                            className="nav-link active"
                            id="pills-collection-name-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-collection-name"
                            type="button" role="tab"
                            aria-controls="pills-collection-name"
                            aria-selected="true"
                            onClick={() => setSelectTab(1)}
                        >
                            <strong>Collection Name</strong>
                        </button>
                    </li>
                    <li className="nav-item mx-lg-5 mx-md-1 mx-5 mt-1" role="presentation" >
                        <button
                            className="nav-link"
                            id="pills-category-name-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-category-name"
                            type="button" role="tab"
                            aria-controls="pills-category-name"
                            aria-selected="false"
                            onClick={() => setSelectTab(2)}
                        >
                            <strong>Category Name</strong>
                        </button>
                    </li>
                    <li className="nav-item mx-lg-5 mx-md-1 mx-5 mt-1" role="presentation">
                        <button
                            className="nav-link"
                            id="pills-activity-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-activity"
                            type="button" role="tab"
                            aria-controls="pills-activity"
                            aria-selected="false"
                            onClick={() => setSelectTab(3)}
                        >
                            <strong>Activity</strong>
                        </button>
                    </li>
                </ul>
            </div>

            <div className="tab-content" id="pills-tabContent">
                <div className={`tab-pane fade show ${selectTab === 1 && "active"}`} id="pills-collection-name" role="tabpanel" aria-labelledby="pills-collection-name-tab">
                    {
                        selectTab === 1 &&
                        <CollectionName
                            useradd={useradd}
                            useredit={useredit}
                            userexport={userexport}
                        />
                    }
                </div>
                <div className={`tab-pane fade show ${selectTab === 2 && "active"}`} id="pills-category-name" role="tabpanel" aria-labelledby="pills-category-name-tab">
                    {
                        selectTab === 2 &&
                        <CategoryName
                            useradd={useradd}
                            useredit={useredit}
                            userexport={userexport}
                        />
                    }
                </div>
                <div className={`tab-pane fade show ${selectTab === 3 && "active"}`} id="pills-activity" role="tabpanel" aria-labelledby="pills-activity-tab">
                    {
                        selectTab === 3 &&
                        <ActivityTab
                            useradd={useradd}
                            useredit={useredit}
                            userexport={userexport}
                        />
                    }
                </div>
            </div>

        </div>
    )
}

export default CollectionMaster
